import * as React from 'react';
import './TitleBar.css';

export interface ITitleBarProps {
  onLeftButtonClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onRightButtonClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  leftIcon: string;
  rightIcon?: string;
  title: string;
}

export const ICO_BAR = 'bars';
export const ICO_CHECK = 'check';
export const ICO_CHECK_ROTATING = 'check-rotating';
export const ICO_CHEVRON_LEFT = 'chevron-left';
export const ICO_ELLIPSIS_V = 'ellipsis-v';
export const ICO_PENCIL_ALT = 'pencil-alt';
export const ICO_SYNC_ALT = 'sync-alt';
export const ICO_SYNC_ALT_ROTATING = 'sync-alt-rotating';


/**
 * Component for title bar with a title and 1 or 2 button (left and right)
 */
class TitleBar extends React.Component<ITitleBarProps, object> {

  public componentDidMount() {
    // Waves.attach('div.button-large', 'waves-light');
  }

  public render() {

    return (
      <div className="titleBar">
        <div className={`leftButton ${this.props.leftIcon}`} onClick={this.props.onLeftButtonClick} />
        <span> {this.props.title}</span>
        {this.props.rightIcon &&
          <div className={`rigthButton ${this.props.rightIcon}`} onClick={this.props.onRightButtonClick} />
        }
        {!this.props.rightIcon &&
          <div className="rigthButton" />
        }
      </div>


    );
  }
}

export default TitleBar;


// WEBPACK FOOTER //
// ./src/components/TitleBar.tsx